var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"Lm5zb2xjcTAgewogIGJvcmRlci1yYWRpdXM6IDRweDsKICBkaXNwbGF5OiBmbGV4OwogIGp1c3RpZnktY29udGVudDogY2VudGVyOwogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgcG9zaXRpb246IHJlbGF0aXZlOwogIG1heC13aWR0aDogNTMxcHg7CiAgbWF4LWhlaWdodDogNDUwcHg7CiAgd2lkdGg6IDEwMCU7CiAgaGVpZ2h0OiAxMDAlOwp9Ci5uc29sY3ExIHsKICB3aWR0aDogMTAwJTsKICBib3JkZXItcmFkaXVzOiA0cHg7Cn0KLm5zb2xjcTIgewogIHBvc2l0aW9uOiBhYnNvbHV0ZTsKICByaWdodDogMzNweDsKICBib3R0b206IDE3cHg7CiAgYm9yZGVyOiBub25lOwogIGJvcmRlci1yYWRpdXM6IDRweDsKICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDsKICBjdXJzb3I6IHBvaW50ZXI7Cn0KLm5zb2xjcTMgewogIHBvc2l0aW9uOiBhYnNvbHV0ZTsKICB3aWR0aDogMTAwJTsKICB0b3A6IDA7CiAgYm90dG9tOiAwOwogIGJvcmRlcjogbm9uZTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDsKICBjdXJzb3I6IHBvaW50ZXI7Cn0=\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};